export default "__VITE_ASSET__D3UD_0rq__"